import { ACCOUNT_ROUTE } from './../../../domain/routes';
import { SetState } from './../../../utils/type';
import { Option } from '../../../utils/option';
import { NextRouter } from 'next/router';
import BasePresenter from '../../basePresenter';
import forgetPasswordInteractor from '../../../application/usecases/forgetPasswordInteractor';
import tracker from '../../../gateways/tracker/tracker';
import { EVENT } from '../../../gateways/tracker/events';
import { createUrl } from '../../../utils/url';
import { WA_SERVICE } from '../../../domain/waService';

export default class ResetPresenter extends BasePresenter {
  constructor(
    readonly router: Option<NextRouter>,
    readonly setIsLoading: SetState<boolean>,
    readonly setIsModalOpen: SetState<boolean>,
    readonly setServerErrMsg: SetState<string>
  ) {
    super(router);
  }

  onRequestModalClose = () => {
    this.setIsModalOpen(false);
  };

  get signInLink() {
    return createUrl(WA_SERVICE.ACCOUNT, ACCOUNT_ROUTE.SIGN_IN, false, {
      redirect_url: this.redirectUrl
    });
  }

  onSubmit = async (email: string): Promise<void> => {
    this.setIsLoading(true);
    this.setServerErrMsg('');
    const result = await forgetPasswordInteractor.sendResetMail(email);
    this.setIsLoading(false);

    if (result && result.error) {
      this.setServerErrMsg(result.error);
      return;
    }
    tracker.track(EVENT.PASSWORD_RESET_SENT).then(() => {
      this.setIsModalOpen(true);
    });
  };
}
